import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  OnChanges,
  ElementRef,
  SimpleChange,
  SimpleChanges,
} from "@angular/core";
import { ProjectService } from "../services/projectservice.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ConfirmationDialogComponent } from "src/app/components/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { HeaderComponent } from "src/app/components/header/header.component";
import { InfoDialogComponent } from "src/app/components/info-dialog/info-dialog.component";
import { ProjectType } from "src/app/enums/projectType.enum";
import { UserRoles } from "src/app/enums/userRoles.enum";
import { OrganizationService } from "src/app/services/Organization/organization.service";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { IctprojectService } from "../services/ictproject.service";
import { MultiFilterComponent } from "src/app/components/multi-filter/multi-filter.component";
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";

import { ProjectServiceService } from "src/app/services/project-service.service";
declare var $: any;

@Component({
  selector: "app-project-dashboard",
  templateUrl: "./project-dashboard.component.html",
  styleUrls: ["./project-dashboard.component.css"],
})
export class ProjectDashboardComponent implements OnInit {
  public formData: UntypedFormGroup;
  public allProjects: any;
  public isFilterDropdownOpen = false;
  public size: number;
  public from: number;
  public loading = false;
  public projectType = 1;
  searchText: any;
  pages: any;
  currentPage: any;
  lastPage: number;
  firstPage: number;
  selectedStatus = "Pending";
  selectedContentType = "Case Studies";

  public permissions = {
    canAddProject: false,
    canUpdateProject: false,
    canDeleteProject: false,
    canViewProject: true,
    canApproveProject: false,
  };

  public ictPermissions = {
    canAddProject: false,
    canUpdateProject: false,
    canDeleteProject: false,
    canViewProject: true,
    canApproveProject: false,
  };

  @ViewChild(HeaderComponent) header: HeaderComponent;
  @ViewChild("actions") actions: ElementRef;
  @ViewChild("searchTerm") searchTerm: ElementRef;
  @ViewChild(MultiFilterComponent) multiFilter: MultiFilterComponent;

  deleteList: any[] = [];
  totalPages: number;
  canAddProject = false;
  projectGridViews: { id: any; name: any }[];
  selectedView: { id: number; name: string };
  userRole: string = this.auth.getRole();
  userOrgID: string = this.auth.getOrganizationId();
  userOrgName: string = this.auth.getOrganizationName();
  selectedorganization: any = { id: this.userOrgID, name: this.userOrgName };
  organizations: any;
  projectCount: any;
  showFilterOptions: boolean;
  isFilterByUser = true;
  contentType: string;
  search: UntypedFormControl;
  contentTypes = [
    "Case Studies",
    "Corporate Deck",
    "Industry Deck",
  ];
  organizationFlag = true;

  constructor(
    private organizationService: OrganizationService,
    private projectService: ProjectService,
    // tslint:disable-next-line: align
    private router: Router,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    private projectDataService: ProjectServiceService,
    // tslint:disable-next-line: align
    public dialog: MatDialog,
    private auth: AuthServiceService,
    private ictProjectService: IctprojectService
  ) {
    this.from = 0;
    this.size = 10;
    this.currentPage = 1;
    this.lastPage = 5;
    this.firstPage = 0;
  }

  ngOnInit() {
    this.contentType = "Case Studies"
    this.searchText = "";
    this.initilizeuserRoles();
    this.search = new UntypedFormControl("");
    if (this.userRole === UserRoles.SuperAdmin) {
      this.organizationService.fetchOrganizationsList().subscribe((res) => {
        this.organizations = res;
        // tslint:disable-next-line: max-line-length
        this.selectedorganization = this.organizations.filter(
          (org) => org.id == this.userOrgID
        )[0];
        this.selectedorganization = this.projectDataService.getOrganization(
          "project-dashboard"
        )
          ? this.projectDataService.getOrganization("project-dashboard")
          : this.selectedorganization;
      });
    }

    this.getValues();
    this.totalPages = this.size + 1;
    if (this.selectedContentType !== "Case Studies") {
      this.getICTProjectsByStatus(
        this.selectedView.name,
        this.selectedContentType
      );
      this.getICTProjectCount(this.selectedView.name, this.selectedContentType);
    } else {
      this.getProjectsByOrganization(this.selectedView.name);
      this.getprojectCount(this.selectedView.name);
    }
  }
  ngAfterViewInit() {
    this.header.backgroundColor = true;
  }


  toggleFilterDropdown(event: Event) {
    event.stopPropagation();
    this.isFilterDropdownOpen = !this.isFilterDropdownOpen;
  }

  closeFilterDropdown() {
    this.isFilterDropdownOpen = false;
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  handleDocumentClick(event: Event) {
    if (this.isFilterDropdownOpen) {
      this.isFilterDropdownOpen = false;
    }
  }

  isFirstPage(): boolean {
    return this.currentPage === 1;
  }
  isLastPage(): boolean {
    return this.currentPage === this.pages.length;
  }
  getValues() {
    this.selectedView = this.projectDataService.getSelectedView()
      ? this.projectDataService.getSelectedView()
      : this.projectGridViews[0];
    this.selectedContentType = this.projectDataService.getSelectedContentType(
      "project-dashboard"
    )
      ? this.projectDataService.getSelectedContentType("project-dashboard")
      : this.contentTypes[0];
    if (
      this.projectDataService.page &&
      this.projectDataService.page === "project-dashboard"
    ) {
      this.from = this.projectDataService.from
        ? this.projectDataService.from
        : 0;
      this.size = this.projectDataService.size
        ? this.projectDataService.size
        : 10;
      this.currentPage = this.projectDataService.currentPage
        ? this.projectDataService.currentPage
        : 1;
    } else {
      this.from = 0;
      this.size = 10;
      this.currentPage = 1;
      this.lastPage = 5;
      this.firstPage = 0;
    }
  }
  setValues() {
    this.projectDataService.setSelectedView(this.selectedView);
    this.projectDataService.setSelectedContentType(this.selectedContentType);
    this.projectDataService.setPageValues(
      this.from,
      this.size,
      this.currentPage
    );
    this.projectDataService.setOrganization(this.selectedorganization);
    this.projectDataService.page = "project-dashboard";
  }

  resetPagination() {
    this.size = 5;
    this.from = 0;
    this.currentPage = 1;
  }
  applyFilter() {
    this.resetPagination();
    this.search.reset();
    this.selectedContentType =
      this.multiFilter.selectedContentType === undefined
        ? this.selectedContentType
        : this.multiFilter.selectedContentType;
    this.selectedorganization =
      this.multiFilter.selectedOrganization === undefined
        ? this.selectedorganization
        : this.multiFilter.selectedOrganization;
    this.selectedView = this.multiFilter.selectedView;

    this.changeGridView(this.selectedView);
    this.changeContentType(this.selectedContentType);
    this.setValues();
  }
  ngOnChanges(changes: SimpleChanges) {
  }

  initilizeuserRoles() {
    this.canAddProject = false;
    this.initilizeGridViews();
    ;
    this.selectedView = this.projectDataService.getSelectedView();
    if (this.selectedView && this.selectedView.name == "Rejected") {
      this.updateSelectedView(ProjectType.Rejected);
    } else {
      this.updateSelectedView(ProjectType.Pending);
    }

  }

  updateFilterView(updateFilterView) {
    this.isFilterByUser = !updateFilterView;
    if (this.isFilterByUser) {
      this.fetchProjects(ProjectType.ApprovedDescription);
    } else {
      this.getProjectsByOrganization(this.selectedView.name);
    }
  }

  getProjectsByOrganization(status) {
    this.loading = true;
    this.getprojectCount(this.selectedStatus);
    this.projectService
      .getProjectsByOrganization(
        this.from,
        this.size,
        status,
        this.selectedorganization.id
      )
      .subscribe(
        (res) => {
          if (status === ProjectType.RejectedDescription) {
            this.allProjects = this.groupRejected(res, "projectId");
          } else {
            this.allProjects = res;
          }
          this.loading = false;
          this.cd.detectChanges();
        },
        (err) => {
          this.loading = false;
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "280px",
            data: { message: err.message, class: "text-danger" },
          });
        }
      );
  }

  initilizeGridViews(isContentApprover?: boolean) {
    this.projectGridViews = [
      { id: ProjectType.Pending, name: ProjectType.PendingDescription },
      { id: ProjectType.Rejected, name: ProjectType.RejectedDescription },
    ];
  }

  changeGridView(projectView) {
    if (this.selectedContentType !== "Case Studies") {
      this.searchTerm.nativeElement.value = "";
      this.updateSelectedView(projectView.id);
      this.selectedStatus = projectView.name;
    } else {
      this.searchTerm.nativeElement.value = "";
      this.updateSelectedView(projectView.id);
      this.selectedStatus = projectView.name;
    }
  }

  updateSelectedView(viewIndex) {

    let isOrganiztionLevel = false;
    this.permissions.canApproveProject = false;
    this.permissions.canUpdateProject = false;
    switch (this.auth.getRole()) {
      case UserRoles.Admin:
        this.permissions.canApproveProject =
          this.permissions.canAddProject =
          this.permissions.canDeleteProject =
          this.permissions.canViewProject =
          this.permissions.canUpdateProject =
          true;
        this.ictPermissions.canApproveProject =
          this.ictPermissions.canUpdateProject =
          this.ictPermissions.canAddProject =
          this.ictPermissions.canDeleteProject =
          this.ictPermissions.canViewProject =
          true;

        break;
      case UserRoles.SuperAdmin:
        isOrganiztionLevel = true;
        this.permissions.canAddProject =
          this.permissions.canUpdateProject =
          this.permissions.canDeleteProject =
          this.permissions.canViewProject =
          true;
        this.ictPermissions.canAddProject =
          this.ictPermissions.canUpdateProject =
          this.ictPermissions.canDeleteProject =
          this.ictPermissions.canViewProject =
          true;

        if (viewIndex === ProjectType.Rejected) {
          this.permissions.canUpdateProject = false;
          this.ictPermissions.canUpdateProject = false;
        } else {
          this.permissions.canUpdateProject =
            this.ictPermissions.canUpdateProject = true;
          this.permissions.canApproveProject =
            this.ictPermissions.canApproveProject = true;
        }
        break;
      case UserRoles.ContentManager:
        this.permissions.canAddProject = this.ictPermissions.canAddProject =
          true;
        if (
          viewIndex === ProjectType.Pending ||
          viewIndex === ProjectType.Rejected
        ) {
          this.permissions.canUpdateProject =
            this.ictPermissions.canUpdateProject =
            this.permissions.canViewProject =
            this.ictPermissions.canViewProject =
            true;
        }

        if (viewIndex === ProjectType.Approved) {
          this.showFilterOptions = true;
        } else {
          this.showFilterOptions = false;
        }
        this.permissions.canDeleteProject =
          this.ictPermissions.canDeleteProject = false;
        break;
    }
    const index = this.projectGridViews.findIndex(
      (ele) => ele.id === viewIndex
    );
    this.selectedView = this.projectGridViews[index];
  }


  searchGrid() {
    if (this.searchText !== "") {
      this.loading = true;
      this.projectService
        .searchGrid(this.searchText, this.selectedView.name)
        .subscribe(
          (res) => {
            this.allProjects = res;

            this.assignPagesValues(this.allProjects.length);
            this.loading = false;
          },
          (err) => {
            this.loading = false;
            const dialogRef = this.dialog.open(InfoDialogComponent, {
              width: "280px",
              data: { message: err.message, class: "text-danger" },
            });
          }
        );
    } else {
      let isOrganiztionLevel = false;
      switch (this.auth.getRole()) {
        case UserRoles.Admin:
          isOrganiztionLevel = true;
          break;
        case UserRoles.SuperAdmin:
          isOrganiztionLevel = true;
          break;
        case UserRoles.ContentManager:
          isOrganiztionLevel = true;
          break;
      }
      isOrganiztionLevel
        ? this.getProjectsByOrganization(this.selectedView.name)
        : this.fetchProjects(this.selectedView.name);
    }
  }
  clearSearchText() {
    this.searchText = "";
    let isOrganiztionLevel = false;
    switch (this.auth.getRole()) {
      case UserRoles.Admin:
        isOrganiztionLevel = true;
        break;
      case UserRoles.SuperAdmin:
        isOrganiztionLevel = true;
        break;
      case UserRoles.ContentManager:
        isOrganiztionLevel = true;
        break;
    }
    isOrganiztionLevel
      ? this.getProjectsByOrganization(this.selectedView.name)
      : this.fetchProjects(this.selectedView.name);
  }


  fetchProjects(status?) {
    if (!status) {
      status = this.selectedView.name;
    }
    this.loading = true;

    this.projectService.getProjectsByOrganization(this.from, this.size, status, this.selectedorganization.id).subscribe(
      (res) => {
        if (status === ProjectType.RejectedDescription) {
          this.allProjects = this.groupRejected(res, "projectId");
        } else {
          this.allProjects = res;
        }
        this.loading = false;
        this.cd.detectChanges();
      },
      (err) => {
        this.loading = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: err.message, class: "text-danger" },
        });
      }
    );
  }

  groupRejected(collection, property: string) {
    // prevents the application from breaking if the array of objects doesn't exist yet
    if (!collection) {
      return null;
    }

    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }

      return previous;
    }, {});
    // this will return an array of objects, each object containing a group of objects
    return Object.keys(groupedCollection).map((key) => ({
      id: groupedCollection[key][0].id,
      projectId: groupedCollection[key][0].projectId,
      projectName: groupedCollection[key][0].projectName,
      bdContact: groupedCollection[key][0].bdContact,
      projectManager: groupedCollection[key][0].projectManager,
      geography: groupedCollection[key][0].geography,
      versionsCount: groupedCollection[key].length,
      showVersions: false,
      versions: groupedCollection[key],
    }));
    // Development pending
  }

  toggleShowVersions(projectIndex) {
    this.allProjects[projectIndex].showVersions =
      !this.allProjects[projectIndex].showVersions;
  }

  handleFileInput(files) {
    this.loading = true;
    const file = files.item(0);
    this.projectService.uploadMultipleProjects(file).subscribe(
      (res) => {
        this.loading = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "Uploaded Successfully.", class: "text-success" },
        });
        dialogRef.afterClosed().subscribe((res1) => {
          if (res1) {

            this.fetchProjects();
          }
        });
      },
      (err) => {

        this.loading = false;
      }
    );
  }

  addProject() {
    this.router.navigate(["project/addProject"]);
  }

  navigate(Id, isView?) {
    this.router.navigate([`Home/KMSPortal/Pending Approvals/View/${Id}`], {
      queryParams: { isView: isView },
    });
  }

  navigateToICT(Id) {
    this.router.navigate([`Home/KMSPortal/Pending Approvals/View/${Id}`], {
      queryParams: { isView: true },
    });
    // if(this.contentType=="Industry Deck")
    //   {
    //     this.router
    //   .navigate(["/Home/KMSPortal/Industry Deck/edit/" + Id])
    //   .then(() => (this.loading = false));
    //   }
    //   else{
    // this.router
    //   .navigate(["/Home/KMSPortal/Corporate Deck/edit/" + Id])
    //   .then(() => (this.loading = false));
    //   }
  }

  onChangeProjectType(val: any) {
    if (val == "Case Studies") {
      //this.router.navigate(["project/addProject"]);
      this.router.navigate(["/Home/KMSPortal/Case Studies/Add"]);
    } else {
      //this.router.navigate(["project/ICT/addICTProject"]);
      if(this.contentType=="Industry Deck")
        {
      this.router.navigate(['Home/KMSPortal/Industry Deck/Add']);
        }
        else{
          this.router.navigate(['Home/KMSPortal/Corporate Deck/Add']);
        }
    }
  }

  changeContentType(contentType: string) {
    this.contentType = contentType;

    if (this.userRole === 'Admin' || this.userRole === 'SuperAdmin') {
      this.ictPermissions.canApproveProject = true;
      this.ictPermissions.canDeleteProject = true;
    }
    if (this.userRole !== "Viewer") {
      this.ictPermissions.canUpdateProject = true;
    }

    if (contentType !== "Case Studies") {
      this.getICTProjectsByStatus(this.selectedView.name, contentType);
      this.getICTProjectCount(this.selectedStatus, contentType);
    } else {
      this.getProjectsByOrganization(this.selectedView.name);
    }
  }

  getICTProjectsByStatus(status: string, contentType: string) {
    this.loading = true;
    this.ictProjectService
      .getProjectsByStatusAndContentType(
        status,
        contentType,
        this.from,
        this.size
      )
      .subscribe(
        (res) => {
          this.allProjects = res;
          this.loading = false;
          this.cd.detectChanges();
        },
        (err) => {
          this.loading = false;
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "280px",
            data: { message: err.message, class: "text-danger" },
          });
        }
      );
  }

  getICTProjectCount(status: string, contentType: string) {
    this.loading = true;
    this.ictProjectService
      .getProjectCountByStatusAndContentType(status, contentType)
      .subscribe(
        (res) => {
          this.loading = false;
          this.assignPagesValues(res);
        },
        (err) => {
          this.loading = false;
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "280px",
            data: { message: err.message, class: "text-danger" },
          });
        }
      );
  }

  deleteICTProjectHistory(projectId: any) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "350px",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === "DELETE") {
        this.loading = true;
        this.ictProjectService.deleteICTProjectHistoryById(projectId).subscribe(
          (res) => {
            this.loading = false;
            setTimeout(() => {
              this.fetchProjects(this.selectedView.name);
              this.changeContentType(this.selectedContentType);
            }, 1000);
          },
          (err) => {
            this.loading = false;
          }
        );
      }
    });
  }

  deleteProject(projectId: any) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "350px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === "DELETE") {
        this.loading = true;
        this.projectService.deleteHistoryDelete(projectId).subscribe(
          (res) => {
            this.loading = false;
            setTimeout(() => {
              this.getProjectsByOrganization(this.selectedView.name);
            }, 1000);
          },
          (err) => {
            this.loading = false;
          }
        );
      }
    });
  }

  addToDeleteList(project, event) {
    if (event.checked) {
      this.deleteList.push(project._id);
    } else {
      const index = this.deleteList.findIndex((ele) => ele === project._id);
      if (index >= 0) {
        this.deleteList.splice(index, 1);
      }
    }
    if (this.deleteList.length > 0) {
      this.actions.nativeElement.style.right = "0px";
    } else {
      this.actions.nativeElement.style.right = "-300px";
    }
  }

  getprojectCount(status) {
    this.loading = true;
    this.projectService
      .getHistoryProjectCount(this.selectedorganization.id, status)
      .subscribe(
        (response) => {
          this.loading = false;
          this.assignPagesValues(response);
        },
        (err) => {
          this.loading = false;
        }
      );
  }

  // assign pagination values
  assignPagesValues(projectCount: number) {
    this.projectCount = projectCount;
    this.pages = [];
    for (let i = 1; i < this.projectCount / this.size; i++) {
      this.pages.push(i);
    }
    this.pages.push(this.pages.length + 1);
  }

  loadMore(pageNumber) {
    if (this.currentPage === pageNumber) {
      return;
    }
    this.currentPage = pageNumber;
    if (pageNumber === 1) {
      this.from = 0;
    } else {
      this.from = --pageNumber * this.size;
    }

    if (this.currentPage === this.firstPage && this.firstPage > 1) {
      this.firstPage = this.firstPage - 1;
    }

    this.projectDataService.page = "project-dashboard";
    if (this.contentType !== "Case Studies") {
      this.getICTProjectsByStatus(this.selectedView.name, this.contentType);
      this.getICTProjectCount(this.selectedStatus, this.contentType);
    } else {
      this.getProjectsByOrganization(this.selectedView.name);
    }
  }

  next() {

    if (this.from + this.size > this.projectCount) {
      return;
    }
    this.from = this.from + this.size;
    this.currentPage++;

    if (this.projectCount / this.size > this.lastPage) {
      this.lastPage = this.lastPage + 1;
      this.firstPage = this.firstPage + 1;
    }

    this.projectDataService.page = "project-dashboard";
    if (this.contentType !== "Case Studies") {
      this.getICTProjectsByStatus(this.selectedView.name, this.contentType);
      this.getICTProjectCount(this.selectedStatus, this.contentType);
    } else {
      this.getProjectsByOrganization(this.selectedView.name);
    }
  }

  previous() {
    if (this.from === 0) {
      return;
    }
    this.from = this.from - this.size;
    this.currentPage--;
    if (this.firstPage !== 0) {
      this.lastPage = this.lastPage - 1;
      this.firstPage = this.firstPage - 1;
    }

    this.projectDataService.page = "project-dashboard";
    if (this.contentType !== "Case Studies") {
      this.getICTProjectsByStatus(this.selectedView.name, this.contentType);
      this.getICTProjectCount(this.selectedStatus, this.contentType);
    } else {
      this.getProjectsByOrganization(this.selectedView.name);
    }
  }

  onChangeOrganization(organization) {
    this.getprojectCount(this.selectedStatus);
    this.getProjectsByOrganization(this.selectedView.name);
  }
  goToHome() {
    this.router.navigate(["/Home"]);
  }

  switchDeckView() {
    this.router.navigate(['/Home/KMSPortal'])
  }

  deleteMultipleProjects() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "300px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === "DELETE") {
        this.loading = true;
        this.projectService.deleteMultipleProjects(this.deleteList).subscribe(
          (res) => {
            this.loading = false;
            this.deleteList = [];
            this.actions.nativeElement.style.right = "-300px";
            setTimeout(() => {
              this.getProjectsByOrganization(this.selectedView.name);
            }, 500);
          },
          (err) => {
            this.loading = false;
          }
        );
      }
    });
  }

  dismissSidebar() {
    $("#sidebar").removeClass("active");
    $("#sidebar_r").removeClass("active");
    $(".overlay").removeClass("active");
  }
}